
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const ChartPieIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM44.5 15.1834C27.92 16.9313 15 30.9568 15 48C15 66.2254 29.7746 81 48 81C55.8519 81 63.0634 78.2577 68.7288 73.6786L45.5251 50.4749C44.8687 49.8185 44.5 48.9283 44.5 48V15.1834ZM73.6786 68.7288C78.2577 63.0634 81 55.8519 81 48C81 30.9568 68.08 16.9313 51.5 15.1834V46.5503L73.6786 68.7288Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM44.5 15.1834C27.92 16.9313 15 30.9568 15 48C15 66.2254 29.7746 81 48 81C55.8519 81 63.0634 78.2577 68.7288 73.6786L45.5251 50.4749C44.8687 49.8185 44.5 48.9283 44.5 48V15.1834ZM73.6786 68.7288C78.2577 63.0634 81 55.8519 81 48C81 30.9568 68.08 16.9313 51.5 15.1834V46.5503L73.6786 68.7288Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
